/**
 * @generated SignedSource<<c443b4255012a95d5a23a1c573dd6664>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductCarousel_viewer">;
  readonly " $fragmentType": "SharedItemTile_viewer";
};
export type SharedItemTile_viewer$key = {
  readonly " $data"?: SharedItemTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedItemTile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerProductCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a28de28afe220148ba681e7b0d6b388a";

export default node;
